module.exports = "<div class=\"form-group\"> <ng-transclude></ng-transclude> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-input-container/dv-input-container.html
// module id = Dw14
// module chunks = 0